import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getHeadLabelStyles } from '../Label.styles';

const PendingChangesNumber = ({ value }) => {
  if (!value) {
    return null;
  }

  return (
    <Typography sx={getHeadLabelStyles({ isPending: true })} variant="regular14">
      <>
        {`${value} Pending `}
        {value > 1 ? 'Changes' : 'Change'}
      </>
    </Typography>
  );
};

PendingChangesNumber.propTypes = {
  value: PropTypes.number,
};

export default PendingChangesNumber;
